import { ASSET_TYPE } from '@/types/asset';
import type { AssetType } from '@/features/GlobalSearch/types/index';

// Search type alias per asset type. LUTs share MOTION_GRAPHICS_COLLECTION but
// need their own alias so the executed search page can apply the
// `is_lut:true` filter and show the LUTs tab.
const assetTypeToSearchTypeParam: Record<AssetType, string> = {
  [ASSET_TYPE.MUSIC]: 'music',
  [ASSET_TYPE.SFX]: 'sfx',
  [ASSET_TYPE.MOTION]: 'mg',
  [ASSET_TYPE.STOCK_VIDEO]: 'sv',
  luts: 'luts',
};

export const mapAssetTypeToSearchTypeParam = (assetType: AssetType) =>
  assetTypeToSearchTypeParam[assetType];
